<canvas id="tpSectors" width="800" height="400"></canvas>
